/** @jsx jsx */
import { jsx, css } from '@emotion/core'

import { Theme } from '@themes/theme'

const Color = (theme: Theme) => css`
  width: inherit;
  height: auto;
  path {
    fill: ${theme.color.blue};
  }
`

export default function UnderOverArrowIco() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="5.143" viewBox="0 0 8 5.143" css={Color} className="under-over-arrow-icon">
      <path id="다각형_12" data-name="다각형 12" d="M3.368.812a.8.8,0,0,1,1.263,0L7,3.852a.8.8,0,0,1-.631,1.291H1.636A.8.8,0,0,1,1,3.852Z" fill="#dc2323"/>
    </svg>
  )
}
